import React, { Component } from 'react'
import firebase from '../../Firebase/firebase';
export class ForgotPass extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            error: ''
        }
    }


    handleInputChange = (event) => {
        this.setState({
            email: event.target.value
        })
    }

    handleSubmit = (event) => {
        event.preventDefault()
        firebase
            .auth()
            .sendPasswordResetEmail(this.state.email)
            .then((user) => {
                console.log(user)

            })
            .catch((error) => {
                this.setState({
                    error: error
                })
            });
    }

    render() {
        var { email,error } = this.state.email
        return (
            <div className="container-fluid" style={{ width: '50%' }}>
                <div className="row">
                    <div className="col-12">
                        <h4>Forgot Password</h4>
                    </div>
                </div>
                {error ? (
                    <div className="row">
                        <div className="col-12">
                            <span>{error.message}</span>
                        </div>
                    </div>
                ) : null}
                <div className="row">
                    <div className="col-12">
                        <form onSubmit={this.handleSubmit} className="form-group">
                            <input type="text" name="email" className="form-control" placeholder="Email" value={email} onChange={this.handleInputChange} />
                            <button className="btn btn-primary">reset Password</button>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default ForgotPass
